import { useCallback, useEffect } from 'react';
import { FullScreenHandle } from 'react-full-screen';
import { ProjectPlanFilter } from 'data/projects';
import { GanttType } from '../helpers';

export const useGanttFilterConfig = ({
  filter,
  showPrivateTasks,
  handle,
  ganttRef,
}: {
  filter: ProjectPlanFilter;
  showPrivateTasks: boolean;
  handle: FullScreenHandle;
  ganttRef: any;
}) => {
  const filterFn = useCallback(
    (recordData) => {
      return (
        filter.primary.filter(recordData, filter.primary) &&
        filter.secondary.filter(recordData, filter.secondary) &&
        ((!handle.active && showPrivateTasks) || !recordData.private)
      );
    },
    [filter.primary, filter.secondary, handle.active, showPrivateTasks],
  );

  const filterRecord = useCallback(
    (record) => {
      const recordData = record.get('data');

      return (
        (record.type === GanttType.ProjectPhaseBar
          ? (!handle.active && showPrivateTasks) || !recordData.private
          : filterFn(recordData)) &&
        /**
         * Filter parent if there are no child nodes or it should have atleast one filtered child node.
         */
        (!record?.children ||
          !!record.children.find((_child) => filterRecord(_child)))
      );
    },
    [filterFn, handle.active, showPrivateTasks],
  );

  useEffect(() => {
    if (!ganttRef) {
      return;
    }

    ganttRef?.instance?.taskStore.filter({
      filters: filterRecord,
      replace: true,
    });
  }, [ganttRef, filterRecord]);
};
